// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 959) return "static/chunks/959-d9d796c92056f311.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"25e7eeca1fab1e49","298":"3c17f9a45cf5b456","340":"b570f6858db25d70","367":"18a99864eb408636","639":"52c56c5acc7171da","748":"25cdd04a17c3fd6a"}[chunkId] + ".js";
};